import { useEffect } from 'react';

import { useSlideEditorContext } from '../context/SlideEditorContext';

/**
 * Registra atalhos de teclado globais para o editor de slides.
 * Deve ser chamado dentro de um componente que está dentro do SlideEditorProvider.
 *
 * - Delete / Backspace → Excluir objeto selecionado
 * - Ctrl+D → Duplicar objeto selecionado
 * - Ctrl+Z → Desfazer
 * - Ctrl+Y / Ctrl+Shift+Z → Refazer
 */
export function useCanvasKeyboard() {
  const ctx = useSlideEditorContext();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      // Do not intercept shortcuts when user is typing in an input
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) return;

      if (e.key === 'Delete' || e.key === 'Backspace') {
        ctx.deleteSelected();
        return;
      }

      const isMod = e.ctrlKey || e.metaKey;

      if (isMod && e.key === 'd') {
        e.preventDefault();
        ctx.duplicateSelected();
        return;
      }

      if (isMod && !e.shiftKey && e.key === 'z') {
        e.preventDefault();
        ctx.undo();
        return;
      }

      if ((isMod && e.key === 'y') || (isMod && e.shiftKey && e.key === 'z')) {
        e.preventDefault();
        ctx.redo();
        return;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [ctx]);
}
